import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd09647a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Your service is now provided by Brightspeed. Please go to ")
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" to manage your account ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_STSLandingGenericError = _resolveComponent("STSLandingGenericError")!
  const _component_PVDialog = _resolveComponent("PVDialog")!
  const _component_STSLandingBody = _resolveComponent("STSLandingBody")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ProgressBar, {
      progress: _ctx.submitProgressValue,
      loading: _ctx.submitProgressBarAppear,
      "loading-status-text": '',
      "longer-than-usual": false,
      "longer-than-usual-status-text": 'Taking longer than usual...'
    }, null, 8, ["progress", "loading", "longer-than-usual-status-text"]),
    _createVNode(_component_STSLandingGenericError, {
      "get-c360-accts-state": _ctx.getC360AcctsStateSubmit,
      "get-r-x-product-info-state": _ctx.getRXProductInfoState,
      "num-key": _ctx.acctNumQuerySubmit
    }, null, 8, ["get-c360-accts-state", "get-r-x-product-info-state", "num-key"]),
    _createVNode(_component_PVDialog, {
      visible: _ctx.isBrightSpeed,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isBrightSpeed) = $event)),
      header: "Brightspeed Customer Notice",
      modal: "true"
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("a", {
          href: _ctx.goToBrightSpeed,
          target: "_blank",
          rel: "noopener nofollow"
        }, "Brightspeed", 8, _hoisted_2),
        _hoisted_3
      ]),
      _: 1
    }, 8, ["visible"]),
    (!_ctx.loadingQueryParams)
      ? (_openBlock(), _createBlock(_component_STSLandingBody, {
          key: 0,
          "update-validation": _ctx.updateValidation,
          "url-query": _ctx.urlQuery,
          "get-r-x-product-info-state": _ctx.getRXProductInfoState
        }, null, 8, ["update-validation", "url-query", "get-r-x-product-info-state"]))
      : _createCommentVNode("", true)
  ], 64))
}